import {TextField, styled, alpha} from '@mui/material'

interface CalendarInputProps {
  contrast?: boolean
}

export const CalendarInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'contrast'
})<CalendarInputProps>(({theme, contrast}) => {
  const baseTextColor = theme.palette.common.white

  const contrastTextColor = theme.palette.getContrastText(theme.palette.background.default)

  const textColor = contrast ? contrastTextColor : baseTextColor

  // Fundamental `border_highlight_10` token (theme-aware; resolves to translucent
  // white on the blue contrast surface).
  const inputBorderColor = 'var(--border_highlight_10)'

  return {
    '& .MuiInputLabel-root': {
      left: '50%',
      transform: 'translateX(-50%)',
      textAlign: 'center',
      color: alpha(textColor, 0.5)
    },

    '& .MuiInputLabel-shrink': {
      transform: 'translateX(-50%) scale(0.75)'
    },

    '& .MuiInputBase-root': {
      textAlign: 'center',
      backgroundColor: 'transparent'
    },

    '& .MuiInputBase-input': {
      textAlign: 'center',
      color: textColor,
      paddingBottom: theme.spacing(1)
    },

    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: contrast ? inputBorderColor : alpha(textColor, 0.25)
    },

    '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: contrast ? inputBorderColor : alpha(textColor, 0.5)
    },

    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: contrast ? theme.palette.primary.main : textColor
    },

    '& .MuiOutlinedInput-root fieldset legend': {
      display: 'none'
    }
  }
})
